module.exports = __webpack_public_path__ + "img/p02.b164be5d.jpg";